// extracted by mini-css-extract-plugin
export default {"dots":"Pager_dots__66VZx","dot":"Pager_dot__+HDjo","passed":"Pager_passed__9aXv5","active":"Pager_active__QY4kr"};